module.exports = __webpack_public_path__ + "d956bae7d8606a35c45976200aa5d2cb.svg";